import { trpc } from '@bitbot/api';
import { createGlobalStore } from 'hox';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useToken } from '../user';

export const [useMarketData] = createGlobalStore(() => {
  const [topDelay, setTopDelay] = useState(false);
  const [favDelay, setFavDelay] = useState(false);
  const router = useRouter();
  const { hasLogin } = useToken();
  useEffect(() => {
    setTimeout(() => {
      setTopDelay(true);
    }, 400);
    setTimeout(() => {
      setFavDelay(true);
    }, 800);
  }, []);
  const {
    data: pairList = [],
    isLoading,
    refetch: refetchPairList,
  } = trpc.market.getPairListFromDex.useQuery(
    {
      chain: 'base',
      dexId: 'uniswap-v2-base',
      sort: 'h24_tx_count_desc',
      page: 0,
    },
    {
      refetchInterval: 20000,
      enabled: router.pathname === '/' || router.pathname === '/trade',
    },
  );
  const {
    data: topList = [],
    isLoading: isTopLoading,
    refetch: refetchTopPairList,
  } = trpc.market.getTopPairList.useQuery(
    {
      chain: 'base',
    },
    {
      refetchInterval: 20000,
      enabled: topDelay && router.pathname === '/',
    },
  );

  const {
    data: favList = [],
    isLoading: isFavLoading,
    refetch: refetchFavPairList,
  } = trpc.market.getFavorPairList.useQuery(
    {
      chain: 'base',
    },
    {
      refetchInterval: 20000,
      enabled:
        favDelay &&
        hasLogin &&
        (router.pathname === '/' || router.pathname === '/trade'),
    },
  );
  return {
    pairList,
    topList,
    favList,
    isLoading,
    isTopLoading,
    isFavLoading,
    refetchPairList,
    refetchFavPairList,
    refetchTopPairList,
  };
});
